function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,1085.000000) scale(0.100000,-0.100000)",
  fill: "#17a345",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3449 10837 c-20 -8 -49 -23 -65 -35 -59 -43 -3343 -3338 -3360 -3372 -23 -45 -24 -143 -2 -190 8 -19 431 -533 939 -1141 508 -608 1228 -1470 1599 -1915 371 -445 702 -840 734 -878 75 -87 142 -122 218 -113 68 8 126 43 163 97 l30 45 3 1166 2 1166 78 17 c328 69 819 116 1217 116 1668 -1 3233 -594 4555 -1725 1068 -914 1997 -2192 2736 -3768 117 -250 150 -289 256 -303 68 -9 126 12 179 65 74 73 77 95 45 346 -256 1983 -832 3673 -1689 4955 -571 853 -1262 1536 -2077 2052 -924 585 -2011 947 -3190 1063 -297 29 -484 37 -840 37 -443 -1 -800 -24 -1157 -76 l-83 -12 -2 1131 c-3 1030 -4 1133 -20 1160 -21 39 -65 83 -101 102 -41 21 -125 26 -168 10z"
}));

var SvgPointer = function SvgPointer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1280.000000pt",
    height: "1085.000000pt",
    viewBox: "0 0 1280.000000 1085.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPointer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pointer.4a7e7c43.svg";
export { ForwardRef as ReactComponent };